import { HubConnectionBuilder } from '@aspnet/signalr/'
import { addStartHook, removeStartHook, addEndHook, removeEndHook } from '$app/auth/auth-session.js'
import getConfigs from './configs'

function buildConnection(entityType) {
  let connection = {};
  let disconnectRequested = false;
  let suspended = false;
  let locksUpdatedFn = (locks) => { };
  let entitiesUpdatedFn = () => { };
  const localLocks = [];

  async function setupConnection() {
    const configs = await getConfigs();
    connection = new HubConnectionBuilder().withUrl(`${configs.apiUrl}arrpHub`).build();
  }

  async function startConnection() {
    try {
      await connection.start();
    } catch (err) {
      console.log(err);
      setTimeout(() => startConnection(), 10000)
    }
  }

  const cleanupLocks = async () => {
    if (connection && !suspended) {
      await Promise.all(localLocks.map(async (lock) =>
        connection.invoke('UnlockItem', entityType, lock)));
    }
  };

  const forceUpdate = async () => {
    const locks = await connection.invoke('GetLocks', entityType);
    locksUpdatedFn(locks);
  };

  const suspendConnection = async () => {
    if (connection) {
      await cleanupLocks();
      suspended = true;
      await connection.stop();
    }
  };

  const resumeConnection = async () => {
    if (connection) {
      suspended = false;
      await startConnection();
      await forceUpdate();
    }
  };

  return ({
    onLocksUpdated(fn) { locksUpdatedFn = fn },
    onEntitiesUpdated(fn) { entitiesUpdatedFn = fn },
    async connect() {
      await setupConnection();
      disconnectRequested = false;
      suspended = false;
      await startConnection();
      await forceUpdate();

      connection.on('LocksUpdated', (entity, locks) => {
        if (!suspended && entity === entityType) {
          locksUpdatedFn(locks);
        }
      });

      connection.on('EntityUpdated', () => {
        if (!suspended) {
          entitiesUpdatedFn();
        }
      });

      connection.onclose(async () => {
        if (!disconnectRequested && !suspended) {
          await startConnection();
        }
      });

      addStartHook(resumeConnection);
      addEndHook(suspendConnection);

      window.addEventListener('beforeunload', cleanupLocks);
    },
    async disconnect() {
      removeStartHook(resumeConnection);
      removeEndHook(suspendConnection);
      if (connection) {
        await cleanupLocks();
        disconnectRequested = true;
        await connection.off();
        await connection.stop();
        connection = null;
      }
      window.removeEventListener('beforeunload', cleanupLocks);
    },
    lockById(id) {
      if (connection && !suspended && connection.connectionState && id) {
        localLocks.push(id);
        connection.invoke('LockItem', entityType, id);
      }
    },
    unlockById(id) {
      if (connection && !suspended && connection.connectionState && id) {
        const lockIdx = localLocks.indexOf(id);
        if (lockIdx !== -1) {
          localLocks.splice(lockIdx, 1);
        }
        connection.invoke('UnlockItem', entityType, id);
      }
    }
  });
}

export {
  buildConnection
}
